/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'navigation.global-shortcuts.all-sites': 'Tous les sites',
  'navigation.global-shortcuts.apps.align': 'Align',
  'navigation.global-shortcuts.apps.analytics': 'Analyses',
  'navigation.global-shortcuts.apps.assets': 'Actifs',
  'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
  'navigation.global-shortcuts.apps.company-hub': "Hub d'entreprise",
  'navigation.global-shortcuts.apps.compass': 'Compass',
  'navigation.global-shortcuts.apps.confluence': 'Confluence',
  'navigation.global-shortcuts.apps.focus': 'Focus',
  'navigation.global-shortcuts.apps.goals': 'Objectifs',
  'navigation.global-shortcuts.apps.home': 'Accueil',
  'navigation.global-shortcuts.apps.jira': 'Jira',
  'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
  'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
  'navigation.global-shortcuts.apps.loom': 'Loom',
  'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
  'navigation.global-shortcuts.apps.projects': 'Projets',
  'navigation.global-shortcuts.apps.studio': 'Studio',
  'navigation.global-shortcuts.apps.talent': 'Talent',
  'navigation.global-shortcuts.apps.teams': 'Équipes',
  'navigation.global-shortcuts.apps.trello': 'Trello',
  'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Fermer',
  'navigation.global-shortcuts.menu-expand-item.site-aria-label': 'Site {name}',
  'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(actuellement indisponible)',
  'navigation.global-shortcuts.menu-link-item.link-external-item-label': "Ouvrir l'icône de lien externe",
  'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(chargement en cours)',
  'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(chargement en cours)',
  'navigation.global-shortcuts.shortcut-action.open-menu-label': 'ouvrir le menu',
  'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
  'navigation.global-shortcuts.sites': 'Sites {productName}',
};
